import { appConfig } from '@common/config';
import { toastOption } from '@hook/useErrorToastMessage';
import { useMutate } from '@network/querys';
import { useAppDispatch, type RootState } from '@store/index';
import { setFavoriteItem } from '@store/priceSlice';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export const FavoriteBtn = ({ itemId, isFav, type, ga360str }: { itemId: number; isFav: boolean; type: string; ga360str: string }) => {
    const [searchParams] = useSearchParams();
    const favoriteItem = useSelector((state: RootState) => state.price.favoriteItem);
    const [isFavorite, isFavoriteSet] = useState(isFav);
    const [favorView, favorViewSet] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        favorViewSet(searchParams.get('favorite') === 'true' || false);

        const favitem = searchParams.get('favitem');
        if (favitem) {
            const [favItemId, isFavItem] = favitem.split('_');
            if (parseInt(favItemId) === itemId) {
                isFavoriteSet(isFavItem === 'true');
            }
        }
    }, [itemId, searchParams]);

    const { mutateAsync } = useMutate();

    const callApi = async (_isFav: boolean) => {
        if (window.isLoginFlag !== 'true') {
            window.GNBLogin?.();
            return;
        }
        (document.activeElement as HTMLElement).blur();

        try {
            await mutateAsync({
                method: _isFav ? 'post' : 'delete',
                apiPath: `/${appConfig.service}/v2.0/my/favorite/${type}/${itemId}`,
                data: null,
            });
            dispatch(setFavoriteItem({ id: itemId, isFavorite: _isFav }));

            toast.dismiss();
            toast((t) => <FavToast isFav={_isFav} favorView={favorView} callFn={callApi} />, toastOption);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (favoriteItem.id === itemId) isFavoriteSet(favoriteItem.isFavorite);
    }, [favoriteItem, itemId]);

    return (
        <button
            className={classNames({ 'is-active': isFavorite }, `btn-favorite`)}
            data-id={itemId}
            data-areas={ga360str}
            onClick={() => callApi(!isFavorite)}
        >
            {isFavorite ? '★' : '☆'}
        </button>
    );
};

export const FavToast = ({ isFav, favorView, callFn }: { isFav: boolean; favorView: boolean; callFn: (isFav: boolean) => void }) => {
    const { t } = useTranslation();
    return (
        <div className={classNames({ 'has-button': !isFav && favorView }, 'toast-wrapper')}>
            <span className="toast-title">{isFav ? t('common.addfavs') : t('common.removefavs')}</span>
            {!isFav && favorView && (
                <button className="toast-cancel" onClick={() => callFn(true)}>
                    {t('common.cancelaction')}
                </button>
            )}
        </div>
    );
};
